import React,{Component} from "react";
import ProfileForm from "../../components/shared/ProfileForm/ProfileForm"
import Grid from "@material-ui/core/Grid";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import AddRegistrForm from "../../components/shared/AddRegistrForm/AddRegistrForm";
import {withStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";


const styles = (theme) => ({
    root: {
        minHeight: '100vh',
        position: 'relative',
        marginTop: 50
    },
    formContainer: {
        boxShadow: 'none'
    }
});

class Profile extends Component{
    state = {
        step: 1
    }

    componentDidMount() {
       // console.log(this.props);
    }

    updateStep = (step) => {
        this.setState({step: step});
    }

    render() {
        const {classes} = this.props;
        return <Container>
            <Grid container component="main" className={classes.root}>
            <CssBaseline/>

                <Grid item xs={1} sm={2} md={2} lg={2}></Grid>
                <Grid item xs={10} sm={8} md={8} lg={8} component={Paper} elevation={6} square className={classes.formContainer}>
                    <ProfileForm

                    />
                </Grid>
                <Grid item xs={1} sm={2} md={2} lg={2}></Grid>
        </Grid></Container>;
    }
}

export default withStyles(styles, {withTheme: true})(Profile);
